import * as angular from 'angular';
import * as _ from 'lodash';

import { ILoggerService } from '../../services';
import { KeyValuePair, IdentifierQuery, ComponentDefinition, ObjectUser, Dictionary } from '../../models';
import { IRootScope } from '../../IRootScope';
import { refreshClick } from '../../common/events';

class IdentifierQuerySelectorController implements angular.IComponentController {
    aggregationModes: KeyValuePair<number, string>[];
    editing: IdentifierQuery;
    existingNames: string[];
    isLoading: boolean;
    isSaving: boolean;
    selectedItem: IdentifierQuery;
    toDelete: IdentifierQuery;
    toDuplicate: IdentifierQuery;

    readonly delete: ({ query: IdentifierQuery }) => void;
    readonly duplicate: ({ query: IdentifierQuery }) => void;
    readonly execute: (args?: { live: boolean }) => void;
    readonly formController: angular.IFormController;
    readonly isEditMode: boolean;
    readonly queries: IdentifierQuery[];
    readonly users: Dictionary<ObjectUser[]>;

    private _garbages: (() => void)[] = [];
    private _timeout: angular.IPromise<void>;
    private _unsavedMessage = 'Save or cancel changes before selecting another query.';

    static $inject = [
        '$rootScope',
        '$timeout',
        '$translate',
        'loggerService'
    ];

    constructor(
        private _$rootScope: IRootScope,
        private _$timeout: angular.ITimeoutService,
        private _$translate: angular.translate.ITranslateService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this._garbages.push(this._$rootScope.$on(refreshClick, () => this.refresh(true)));
        this.harvestNames();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['queries']?.currentValue) {
            this.harvestNames();
        }
    }


    $onDestroy() {
        this._garbages.forEach(w => w());
    }

    private cancelTimeout() {
        if (this._timeout) {
            this._$timeout.cancel(this._timeout);
        }
    }

    refresh(live?: boolean) {
        this.cancelTimeout();
        this._timeout = this._$timeout(() => {
            this.execute(live ? { live: true } : undefined);
        });
    }

    clickDelete(query: IdentifierQuery) {
        if (query.isCreating) {
            this.selectedItem = null;
            if (this.formController) {
                this.formController.$setPristine();
            }
        } else {
            this.delete({ query });
        }
    }

    clickDuplicate(name: string) {
        const query = Object.assign({}, this.toDuplicate);
        query.name = name;
        query.guid = undefined;
        this.duplicate({ query });
    }

    onDuplicate(query: IdentifierQuery, $event: angular.IAngularEvent) {
        this.toDuplicate = query;
        if ($event && $event.preventDefault) {
            $event.preventDefault();
        }
    }

    onDelete(query: IdentifierQuery, $event: angular.IAngularEvent) {
        this.toDelete = query;
        if ($event && $event.preventDefault) {
            $event.preventDefault();
        }
    }

    select(query: IdentifierQuery, $event) {
        if (!$event.isDefaultPrevented()) {
            if (this.formController && this.formController.$dirty) {
                const msg = this._$translate.instant(this._unsavedMessage);
                this._loggerService.logWarning(msg, true);
            } else {
                this.selectedItem = query;
            }
        }
        if ($event && $event.preventDefault) {
            $event.preventDefault();
        }
    }

    private harvestNames() {
        this.existingNames = this.queries?.map(q => q.name) ?? [];
    }
}

export const wtIdentifierQuerySelector: ComponentDefinition = {
    componentId: 'wtIdentifierQuerySelector',
    controller: IdentifierQuerySelectorController,
    template: require('./identifierQuerySelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        delete: '&',
        duplicate: '&',
        execute: '&',
        formController: '<',
        isEditMode: '<',
        queries: '<',
        selectedItem: '=',
        users: '<'
    }
};